import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../common/utils/restApiHeaderUtils';
import { getCollectionFields, getCollectionFieldTraitOptions } from './plugins/pluginComponentApi';
const restrictedFields = ['password', 'updatedAt', 'createdBy', 'updatedBy', 'version'];
//TODO: This cannot be replaced as it is used in Link Traits
const getTraitCollectionFields = async (header, collectionName, projectId, version) => {
  const url = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/collections/${projectId}/project/${collectionName}/name`;
  return await axios.get(url, header);
};
export const getFieldsTraits = async (collectionName, projectId, version, collections) => {
  let collection = null;
  console.log('*** Version:', version);
  try {
    if (collections) {
      collection = await getCollectionFields(collectionName, collections);
    } else {
      const header = builderSurfaceJsonContentHeader(projectId);
      let { data } = await getTraitCollectionFields(header, collectionName, projectId, version);
      collection = data;
    }
  } catch (_err) {
    console.error('_err', _err);
  }
  let options = [];
  let collectionTitle = '';
  const collectionId = collectionName;
  if (collection && collection.collectionTitle) {
    options = await getCollectionFieldTraitOptions(collection, collections);
    collectionTitle = collection.collectionTitle;
  }
  return { options, collectionTitle, collectionId };
};

const getPageById = async (pageId, version, header) => {
  const url = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/pages/${pageId}`;
  return axios.get(url, header);
};

const getSnippetById = async (projectId, version, snippetId, header) => {
  const url = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/snippet-templates/${snippetId}`;
  return axios.get(url, header);
};
export const getPageCollectionFields = async (
  pageId,
  projectId,
  version,
  isLoginPlugin,
  collections,
  multiTenantPlugin,
) => {
  const header = builderSurfaceJsonContentHeader(projectId);
  const pageResponse = await getPageById(pageId, version, header);
  let response = [];
  const isMultiTenantPlugin = !!multiTenantPlugin;
  if (pageResponse && pageResponse.data) {
    response.page = pageResponse.data;
  }
  if (isLoginPlugin && pageResponse.data.access !== 'PERMIT_ALL') {
    const userFields = await getFieldsTraits('user', projectId, version, collections);
    userFields.options = userFields.options.filter((option) => {
      return !restrictedFields.includes(option.id);
    });
    response.session = userFields;
  }
  if (isMultiTenantPlugin) {
    console.log('*** Multi Tenant Plugin Installed.');
    const multiTenantCollection =
      collections && collections.find((collection) => collection.isTenantCollection);
    console.log('*** Multi Tenant Collection:', multiTenantCollection);
    const multiTenantFields = multiTenantCollection
      ? await getFieldsTraits(multiTenantCollection.collectionName, projectId, version, collections)
      : '';

    if (multiTenantFields && multiTenantFields.options) {
      multiTenantFields.options = multiTenantFields.options.filter((option) => {
        return !restrictedFields.includes(option.id);
      });
    }
    response.sessionTenant = multiTenantFields;
    const userSettingCollection =
      collections && collections.find((collection) => collection.isUserSettingCollection);
    const userSettingFields = userSettingCollection
      ? await getFieldsTraits(userSettingCollection.collectionName, projectId, version, collections)
      : '';

    if (userSettingFields && userSettingFields.options) {
      userSettingFields.options = userSettingFields.options.filter((option) => {
        return !restrictedFields.includes(option.id);
      });
    }
    response.sessionUserSettings = userSettingFields;
    const subTenantCollection =
      collections && collections.find((collection) => collection.isSubTenantCollection);
    const subTenantFields = subTenantCollection
      ? await getFieldsTraits(subTenantCollection.collectionName, projectId, version, collections)
      : '';

    if (subTenantFields && subTenantFields.options) {
      subTenantFields.options = subTenantFields.options.filter((option) => {
        return !restrictedFields.includes(option.id);
      });
    }
    response.sessionSubTenant = subTenantFields;
  }
  if (pageResponse.data.collectionId) {
    response.collection = await getFieldsTraits(
      pageResponse.data.collectionId,
      projectId,
      version,
      collections,
    );
  }
  return response;
};

export const getProjectById = async (projectId, version, header) => {
  const url = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/`;
  return axios.get(url, header);
};

export const camelize = function (str) {
  return str
    .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    })
    .replace(/\s+/g, '');
};

export const parameterize = function (str) {
  return str
    .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
      return word.toLowerCase();
    })
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^a-zA-Z0-9]+/g, '-');
};

export const getSnippetCollectionFields = async (snippetId, projectId, version, collections) => {
  const header = builderSurfaceJsonContentHeader(projectId);
  const snippetResponse = await getSnippetById(projectId, version, snippetId, header);
  console.log('🚀 ~ getSnippetCollectionFields ~ snippetId:', snippetId);
  let response = [];
  if (snippetResponse && snippetResponse.data) {
    response.snippet = snippetResponse.data;
    if (snippetResponse.data.collectionId) {
      response.collection = await getFieldsTraits(
        snippetResponse.data.collectionId,
        projectId,
        version,
        collections,
      );
    }
  }

  return response;
};

export const createRedirectUrl = () => {
  let domainName = window.location.hostname;
  let redirectUrl = `https://${domainName}/`;
  const environment = process.env.REACT_APP_ENVIRONMENT;
  if (environment === 'DEV') {
    redirectUrl = `http://${domainName}:9075/`;
  } else if (environment === 'STAGING') {
    domainName = domainName.replace('builder.webkonnect.xyz', 'builderc.webkonnect.xyz');
    redirectUrl = `https://${domainName}/`;
  } else {
    domainName = domainName.replace('builder.mydrapcode.com', 'builderc.mydrapcode.com');
    redirectUrl = `https://${domainName}/`;
  }
  return redirectUrl;
};

export const getAllTypesenseSearchTemplates = async (projectId, version) => {
  const header = builderSurfaceJsonContentHeader(projectId);
  const url = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/templates?templateType=TYPESENSE_SEARCH`;
  const response = await axios.get(url, header);
  if (response && response.data && response.data.length) {
    return response.data;
  } else return [];
};

export const phoneNumberCountryCode = [
  { name: 'Afghanistan', id: 'af' },
  { name: 'Albania', id: 'al' },
  { name: 'Algeria', id: 'dz' },
  { name: 'American Samoa', id: 'as' },
  { name: 'Andorra', id: 'ad' },
  { name: 'Angola', id: 'ao' },
  { name: 'Anguilla', id: 'ai' },
  { name: 'Antarctica', id: 'aq' },
  { name: 'Antigua and Barbuda', id: 'ag' },
  { name: 'Argentina', id: 'ar' },
  { name: 'Armenia', id: 'am' },
  { name: 'Aruba', id: 'aw' },
  { name: 'Australia', id: 'au' },
  { name: 'Austria', id: 'at' },
  { name: 'Azerbaijan', id: 'az' },
  { name: 'Bahamas', id: 'bs' },
  { name: 'Bahrain', id: 'bh' },
  { name: 'Bangladesh', id: 'bd' },
  { name: 'Barbados', id: 'bb' },
  { name: 'Belarus', id: 'by' },
  { name: 'Belgium', id: 'be' },
  { name: 'Belize', id: 'bz' },
  { name: 'Benin', id: 'bj' },
  { name: 'Bermuda', id: 'bm' },
  { name: 'Bhutan', id: 'bt' },
  { name: 'Bolivia', id: 'bo' },
  { name: 'Bosnia and Herzegovina', id: 'ba' },
  { name: 'Botswana', id: 'bw' },
  { name: 'Brazil', id: 'br' },
  { name: 'British Indian Ocean Territory', id: 'io' },
  { name: 'Brunei Darussalam', id: 'bn' },
  { name: 'Bulgaria', id: 'bg' },
  { name: 'Burkina Faso', id: 'bf' },
  { name: 'Burundi', id: 'bi' },
  { name: 'Cambodia', id: 'kh' },
  { name: 'Cameroon', id: 'cm' },
  { name: 'Canada', id: 'ca' },
  { name: 'Cape Verde', id: 'cv' },
  { name: 'Cayman Islands', id: 'ky' },
  { name: 'Central African Republic', id: 'cf' },
  { name: 'Chad', id: 'td' },
  { name: 'Chile', id: 'cl' },
  { name: 'China', id: 'cn' },
  { name: 'Colombia', id: 'co' },
  { name: 'Comoros', id: 'km' },
  { name: 'Congo', id: 'cg' },
  { name: 'Congo (Democratic Republic)', id: 'cd' },
  { name: 'Costa Rica', id: 'cr' },
  { name: 'Croatia', id: 'hr' },
  { name: 'Cuba', id: 'cu' },
  { name: 'Cyprus', id: 'cy' },
  { name: 'Czech Republic', id: 'cz' },
  { name: 'Denmark', id: 'dk' },
  { name: 'Djibouti', id: 'dj' },
  { name: 'Dominica', id: 'dm' },
  { name: 'Dominican Republic', id: 'do' },
  { name: 'Ecuador', id: 'ec' },
  { name: 'Egypt', id: 'eg' },
  { name: 'El Salvador', id: 'sv' },
  { name: 'Estonia', id: 'ee' },
  { name: 'Ethiopia', id: 'et' },
  { name: 'Fiji', id: 'fj' },
  { name: 'Finland', id: 'fi' },
  { name: 'France', id: 'fr' },
  { name: 'Germany', id: 'de' },
  { name: 'Ghana', id: 'gh' },
  { name: 'Greece', id: 'gr' },
  { name: 'Greenland', id: 'gl' },
  { name: 'Grenada', id: 'gd' },
  { name: 'Guatemala', id: 'gt' },
  { name: 'Guinea', id: 'gn' },
  { name: 'Guinea-Bissau', id: 'gw' },
  { name: 'Guyana', id: 'gy' },
  { name: 'Haiti', id: 'ht' },
  { name: 'Honduras', id: 'hn' },
  { name: 'Hong Kong', id: 'hk' },
  { name: 'Hungary', id: 'hu' },
  { name: 'Iceland', id: 'is' },
  { name: 'India', id: 'in' },
  { name: 'Indonesia', id: 'id' },
  { name: 'Iran', id: 'ir' },
  { name: 'Iraq', id: 'iq' },
  { name: 'Ireland', id: 'ie' },
  { name: 'Israel', id: 'il' },
  { name: 'Italy', id: 'it' },
  { name: 'Jamaica', id: 'jm' },
  { name: 'Japan', id: 'jp' },
  { name: 'Jordan', id: 'jo' },
  { name: 'Kazakhstan', id: 'kz' },
  { name: 'Kenya', id: 'ke' },
  { name: 'Kuwait', id: 'kw' },
  { name: 'Kyrgyzstan', id: 'kg' },
  { name: 'Laos', id: 'la' },
  { name: 'Latvia', id: 'lv' },
  { name: 'Lebanon', id: 'lb' },
  { name: 'Lesotho', id: 'ls' },
  { name: 'Liberia', id: 'lr' },
  { name: 'Libya', id: 'ly' },
  { name: 'Lithuania', id: 'lt' },
  { name: 'Luxembourg', id: 'lu' },
  { name: 'Macau', id: 'mo' },
  { name: 'Macedonia', id: 'mk' },
  { name: 'Madagascar', id: 'mg' },
  { name: 'Malawi', id: 'mw' },
  { name: 'Malaysia', id: 'my' },
  { name: 'Maldives', id: 'mv' },
  { name: 'Mali', id: 'ml' },
  { name: 'Malta', id: 'mt' },
  { name: 'Mauritius', id: 'mu' },
  { name: 'Mexico', id: 'mx' },
  { name: 'Moldova', id: 'md' },
  { name: 'Monaco', id: 'mc' },
  { name: 'Mongolia', id: 'mn' },
  { name: 'Montenegro', id: 'me' },
  { name: 'Morocco', id: 'ma' },
  { name: 'Mozambique', id: 'mz' },
  { name: 'Myanmar', id: 'mm' },
  { name: 'Namibia', id: 'na' },
  { name: 'Nepal', id: 'np' },
  { name: 'Netherlands', id: 'nl' },
  { name: 'New Zealand', id: 'nz' },
  { name: 'Nicaragua', id: 'ni' },
  { name: 'Niger', id: 'ne' },
  { name: 'Nigeria', id: 'ng' },
  { name: 'Norway', id: 'no' },
  { name: 'Oman', id: 'om' },
  { name: 'Pakistan', id: 'pk' },
  { name: 'Palestine', id: 'ps' },
  { name: 'Panama', id: 'pa' },
  { name: 'Papua New Guinea', id: 'pg' },
  { name: 'Paraguay', id: 'py' },
  { name: 'Peru', id: 'pe' },
  { name: 'Philippines', id: 'ph' },
  { name: 'Poland', id: 'pl' },
  { name: 'Portugal', id: 'pt' },
  { name: 'Puerto Rico', id: 'pr' },
  { name: 'Qatar', id: 'qa' },
  { name: 'Romania', id: 'ro' },
  { name: 'Russia', id: 'ru' },
  { name: 'Rwanda', id: 'rw' },
  { name: 'Saint Kitts and Nevis', id: 'kn' },
  { name: 'Saint Lucia', id: 'lc' },
  { name: 'Saint Vincent and the Grenadines', id: 'vc' },
  { name: 'Samoa', id: 'ws' },
  { name: 'San Marino', id: 'sm' },
  { name: 'Saudi Arabia', id: 'sa' },
  { name: 'Senegal', id: 'sn' },
  { name: 'Serbia', id: 'rs' },
  { name: 'Seychelles', id: 'sc' },
  { name: 'Sierra Leone', id: 'sl' },
  { name: 'Singapore', id: 'sg' },
  { name: 'Slovakia', id: 'sk' },
  { name: 'Slovenia', id: 'si' },
  { name: 'Solomon Islands', id: 'sb' },
  { name: 'Somalia', id: 'so' },
  { name: 'South Africa', id: 'za' },
  { name: 'South Korea', id: 'kr' },
  { name: 'Spain', id: 'es' },
  { name: 'Sri Lanka', id: 'lk' },
  { name: 'Sudan', id: 'sd' },
  { name: 'Suriname', id: 'sr' },
  { name: 'Swaziland', id: 'sz' },
  { name: 'Sweden', id: 'se' },
  { name: 'Switzerland', id: 'ch' },
  { name: 'Syria', id: 'sy' },
  { name: 'Taiwan', id: 'tw' },
  { name: 'Tajikistan', id: 'tj' },
  { name: 'Tanzania', id: 'tz' },
  { name: 'Thailand', id: 'th' },
  { name: 'Togo', id: 'tg' },
  { name: 'Tonga', id: 'to' },
  { name: 'Trinidad and Tobago', id: 'tt' },
  { name: 'Tunisia', id: 'tn' },
  { name: 'Turkey', id: 'tr' },
  { name: 'Turkmenistan', id: 'tm' },
  { name: 'Uganda', id: 'ug' },
  { name: 'Ukraine', id: 'ua' },
  { name: 'United Arab Emirates', id: 'ae' },
  { name: 'United Kingdom', id: 'gb' },
  { name: 'United States', id: 'us' },
  { name: 'Uruguay', id: 'uy' },
  { name: 'Uzbekistan', id: 'uz' },
  { name: 'Vanuatu', id: 'vu' },
  { name: 'Vatican City', id: 'va' },
  { name: 'Venezuela', id: 've' },
  { name: 'Vietnam', id: 'vn' },
  { name: 'Yemen', id: 'ye' },
  { name: 'Zambia', id: 'zm' },
  { name: 'Zimbabwe', id: 'zw' },
];
